module.exports = __webpack_public_path__ + "img/20200801_131327.bfd6db84.jpg";